import React from 'react';
import { Key, AlertCircle } from 'lucide-react';

const ApiKeyModal = ({ 
  showApiKeyModal, 
  tempApiKey, 
  setTempApiKey, 
  saveApiKey, 
  setShowApiKeyModal, 
  apiKey, 
  apiError 
}) => {
  if (!showApiKeyModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <Key className="icon" />
          <h2>Gemini APIキーの設定</h2>
        </div>
        
        <p className="modal-description">
          Gemini APIを利用するためにAPIキーが必要です。
          <a 
            href="https://makersuite.google.com/app/apikey" 
            target="_blank" 
            rel="noopener noreferrer"
            className="link"
          >
            こちら
          </a>
          から取得できます。
        </p>
        
        <input
          type="password"
          value={tempApiKey}
          onChange={(e) => setTempApiKey(e.target.value)}
          placeholder="APIキーを入力..."
          className="input-field"
        />
        
        {apiError && (
          <div className="error-message">
            <AlertCircle className="icon-small" />
            <p>{apiError}</p>
          </div>
        )}
        
        <div className="modal-actions">
          <button
            onClick={saveApiKey}
            disabled={!tempApiKey.trim()}
            className="btn btn-primary"
          >
            保存
          </button>
          {apiKey && (
            <button
              onClick={() => setShowApiKeyModal(false)}
              className="btn btn-secondary"
            >
              キャンセル
            </button>
          )}
        </div>
        
        <p className="modal-note">
          ※ APIキーはブラウザのローカルストレージに保存されます。サーバーには送信されません。
        </p>
      </div>
    </div>
  );
};

export default ApiKeyModal;